import { __spreadArrays } from "tslib";
import { bytes, bibytes, deprecatedBytes, } from "../constants";
import { matchDataUnit } from "./util";
export var dataFormatUnits = [
    bytes,
    bibytes,
    // deprecated
    deprecatedBytes,
];
export var dataFormatUnitIds = [].concat.apply([], dataFormatUnits.map(function (dataFormatUnitGroup) { return __spreadArrays(dataFormatUnitGroup.map(function (dataFormatUnit) { return dataFormatUnit.id; }), [].concat.apply([], dataFormatUnitGroup.map(function (dataFormatUnit) {
    return dataFormatUnit.alias ? dataFormatUnit.alias : [];
}))); }));
export function humanizeDataValue(value, unit, targetUnit) {
    var baseDataUnitGroupIndex = dataFormatUnits.length - 1;
    var baseDataUnitIndex = 0;
    var targetDataUnitIndex = -1;
    var sign = Math.sign(value);
    var positiveValue = Math.abs(value);
    if (unit) {
        var _loop_1 = function (i) {
            var _baseDataUnitIndex = -1;
            var _targetDataUnitIndex = -1;
            dataFormatUnits[i].forEach(function (dataUnit, index) {
                if (matchDataUnit(dataUnit, unit))
                    _baseDataUnitIndex = index;
                if (matchDataUnit(dataUnit, targetUnit))
                    _targetDataUnitIndex = index;
            });
            if (_baseDataUnitIndex !== -1) {
                baseDataUnitGroupIndex = i;
                baseDataUnitIndex = _baseDataUnitIndex;
                targetDataUnitIndex = _targetDataUnitIndex;
                return "break";
            }
        };
        for (var i = 0; i < dataFormatUnits.length; ++i) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
    }
    else if (targetUnit) {
        targetDataUnitIndex = dataFormatUnits[baseDataUnitGroupIndex].findIndex(function (dataUnit) { return matchDataUnit(dataUnit, targetUnit); });
    }
    var dataFormatUnitGroup = dataFormatUnits[baseDataUnitGroupIndex];
    var baseDataFormatUnit = dataFormatUnitGroup[baseDataUnitIndex];
    var targetDataFormatUnit = baseDataFormatUnit;
    if (targetDataUnitIndex === -1) {
        for (var i = baseDataUnitIndex + 1; i < dataFormatUnitGroup.length; ++i) {
            if (positiveValue /
                (dataFormatUnitGroup[i].divisor / baseDataFormatUnit.divisor) >=
                1) {
                targetDataFormatUnit = dataFormatUnitGroup[i];
            }
            else {
                break;
            }
        }
    }
    else {
        targetDataFormatUnit = dataFormatUnitGroup[targetDataUnitIndex];
    }
    if (targetUnit && targetDataUnitIndex === -1) {
        console.warn("Cannot convert unit \"" + (unit || baseDataFormatUnit.display) + "\" to \"" + targetUnit + "\"");
    }
    return [
        (positiveValue /
            (targetDataFormatUnit.divisor / baseDataFormatUnit.divisor)) *
            sign,
        targetDataFormatUnit.display,
    ];
}
//# sourceMappingURL=data.js.map